export var FullPagePadding = 32;
export var TELEPOINTER_ID = 'ai-streaming-telepointer';